enum Locales {
  EN = 'en',
  DE = 'de',
  ES = 'es',
  IT = 'it',
  FR = 'fr',
}

enum BackendLocales {
  EN = 'EN',
  DE = 'DE',
  ES = 'ES',
  IT = 'IT',
  FR = 'FR',
}

enum OnBoardingSellerStep {
  PERSONAL_INFORMATION = 'personal-information',
  SHIPPING_POLICY = 'shipping-policy',
  PAYOUT = 'payout',
  BUSINESS_INFORMATION = 'business-information',
  FINISH = 'finish',
}

enum OnBoardingBusinessInformationStep {
  IS_BUSINESS_OWNER = 'is-business-owner',
  COMPANY_TYPE = 'company-type',
  SHAREHOLDERS = 'shareholders',
  BUSINESS_INFORMATION = 'business-information',
  SHIPPING_POLICY = 'shipping-policy',
}

enum OnBoardingBuyerStep {
  PERSONAL_INFORMATION = 'personal-information',
  PAYMENT_METHOD = 'payment-method',
  BUSINESS_INFORMATION = 'business-information',
  FINISH = 'finish',
}

export {
  Locales,
  BackendLocales,
  OnBoardingSellerStep,
  OnBoardingBuyerStep,
  OnBoardingBusinessInformationStep,
};
